import { Serializable } from "../utilities/Serializable";
import { Card } from "./Card";
import { CardTransaction } from "./CardTransaction";
import { CouponTransaction } from "./CouponTransaction";

export class CardStatement extends Serializable {
    card: Card;
    cardTransactions: CardTransaction[];
    couponTransactions: CouponTransaction[];
    constructor() {
        super();
        this.card = new Card();
        this.cardTransactions = [];
        this.couponTransactions= [];
    }
}


// WEBPACK FOOTER //
// ./src/app/models/CardStatement.ts